import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function StickyCTA({ onJoinClick, whatsappNumber = "" }) {
  const wa = whatsappNumber || "447000000000";
  return (
    <>
      {/* Floating WhatsApp — visible on all breakpoints */}
      <a
        href={`https://wa.me/${wa.replace(/[^0-9]/g, "")}`}
        target="_blank"
        rel="noreferrer"
        data-testid="sticky-whatsapp"
        className="fixed bottom-24 right-4 z-40 grid h-14 w-14 place-items-center rounded-full bg-[hsl(148_50%_35%)] text-white shadow-lg transition-transform hover:-translate-y-1 md:bottom-6"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="h-6 w-6" strokeWidth={1.75} />
      </a>

      {/* Sticky mobile join bar */}
      <div className="fixed inset-x-0 bottom-0 z-30 border-t border-border bg-[hsl(40_33%_98%)]/95 backdrop-blur md:hidden">
        <div className="flex items-center gap-3 p-3">
          <Button
            onClick={onJoinClick}
            data-testid="sticky-join-btn"
            className="flex-1 rounded-full bg-[hsl(41_85%_55%)] py-5 text-sm font-medium text-[hsl(150_20%_15%)] hover:bg-[hsl(41_85%_50%)]"
          >
            Join Waiting List
          </Button>
        </div>
      </div>
    </>
  );
}
